const QualityCheckIcon = () => {
  return (
    <svg
      width='48'
      height='36'
      viewBox='0 0 48 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M48.0009 -0.000244141H17.2812V2.44246C22.5745 4.16118 26.4012 9.13366 26.4012 14.9999C26.4012 20.8661 22.5745 25.8386 17.2812 27.5573V36.0001H48.0009V-0.000244141Z'
        fill='#E4E9FF'
      />
      <path
        d='M26.3485 16.1829C26.3831 15.7932 26.4008 15.3983 26.4008 14.9998C26.4008 14.1813 26.3258 13.3774 26.1831 12.5998H43.201V16.1999H26.3471C26.3475 16.194 26.3481 16.1887 26.3485 16.1829Z'
        fill='#CDD6FF'
      />
      <path
        d='M25.501 19.7999C24.9878 21.113 24.2693 22.3271 23.3866 23.3964C23.3856 23.3976 23.3847 23.3987 23.3836 23.3999H40.8009V19.7999H25.501Z'
        fill='#CDD6FF'
      />
      <path
        d='M24.9614 8.99978H43.201V5.99976H22.8569C23.6872 6.89039 24.3965 7.89645 24.9568 8.99041C24.9584 8.99334 24.9598 8.99685 24.9614 8.99978Z'
        fill='#CDD6FF'
      />
      <path d='M22.8008 26.3999H34.8009V30H22.8008V26.3999Z' fill='#CDD6FF' />
      <path
        d='M11.29 18.7742L7.26199 14.7482L8.6015 13.4094L11.29 16.0966L18.6621 8.82313L20.0111 10.162L11.2995 18.7742H11.29Z'
        fill='#0000C9'
      />
      <path
        d='M18.8961 13.9981C18.9436 14.3304 18.9721 14.6628 18.9721 15.0046C18.9721 19.1825 15.5805 22.5724 11.4005 22.5724C7.22044 22.5724 3.82891 19.1825 3.82891 15.0046C3.82891 10.8266 7.22044 7.43681 11.4005 7.43681C13.025 7.43681 14.526 7.94955 15.761 8.82313L17.1385 7.4463C15.5425 6.2309 13.557 5.49976 11.4005 5.49976C6.15643 5.50925 1.90039 9.76316 1.90039 15.0046C1.90039 20.246 6.15643 24.4999 11.4005 24.4999C16.6445 24.4999 20.9006 20.246 20.9006 15.0046C20.9006 14.093 20.7676 13.21 20.5206 12.3744L18.8961 13.9981Z'
        fill='#0000C9'
      />
    </svg>
  );
};

export default QualityCheckIcon;
